import * as React from 'react';

import type {
  InfluencerCreatorNetworkListContext as InfluencerCreatorNetworkListContextType
} from 'modules/influencers/components/creator-network/list/types/InfluencerCreatorNetworkList.type';

const InfluencerCreatorNetworkListContext =
  React.createContext<InfluencerCreatorNetworkListContextType | undefined>(undefined);

export default InfluencerCreatorNetworkListContext;
